<template>
  <div
    v-if="showBanner"
    class="fixed-bottom w-100 pointer-events-none pixels-bg"
    style="padding: 15px 0 20px 0; background: rgba(0, 0, 0, .5); color: #fff; box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);"
  >
    <div class="container">
      <div class="d-flex align-items-center justify-content-between px-6 py-2 rounded mx-auto banner-inner">
        <div>
          <h3 class="mb-0">Cookie Consent</h3>
          <p class="mb-0">
            By clicking “Accept”, you agree to the storing of cookies on your device to enhance site navigation, analyze site
            usage, and assist in our marketing efforts. View our
            <a href="/privacy-policy" style="color: #00b4b4;">privacy policy</a> for details.
          </p>
        </div>
        <button
          type="button"
          class="btn flex-none dismiss-btn"
          style="background: #00b4b4; color: #fff; padding: 5px 10px"
          @click="acceptCookies"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyBanner",
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    this.showBanner = !this.getCookie("SSCAnalytics");
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop().split(";").shift() === "accepted" ? "accepted" : null;
      }
      return null;
    },

    setCookie(name, value, days = 365) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;

      const isProduction = window.location.hostname.includes("spacesaver.com");
      const domain = isProduction ? "domain=.spacesaver.com;" : "";

      // Improved security settings
      document.cookie = `${name}=${value};${expires};path=/;${domain}SameSite=Strict;Secure`;
    },

    acceptCookies() {
      this.setCookie("SSCAnalytics", "accepted");
      this.showBanner = false;
    },
  },
};
</script>